import { render, staticRenderFns } from "./OverlayContentComp.vue?vue&type=template&id=5c8d4614&scoped=true"
import script from "./OverlayContentComp.vue?vue&type=script&lang=ts"
export * from "./OverlayContentComp.vue?vue&type=script&lang=ts"
import style0 from "./OverlayContentComp.vue?vue&type=style&index=0&id=5c8d4614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d4614",
  null
  
)

export default component.exports